import {
  SUPPLIER_RISK_CLASSIFICATION,
  SUPPLIER_CATEGORIES,
  SUPPLIERS_MANAGE_PERSONAL_DATA,
} from '@/lib/constants/suppliers'
const PERSONAL_DATA_LABELS = {
  [SUPPLIERS_MANAGE_PERSONAL_DATA.NONE]: 'Ninguno',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.BASIC_IDENTIFICATION]: 'Identificación Básica',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.FINANCIAL_DATA]: 'Financiero',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.HEALTH_DATA]: 'Salud',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.SPECIAL_CATEGORIES]: 'Especial',
  [SUPPLIERS_MANAGE_PERSONAL_DATA.OTHER]: 'Otro',
}
const RISK_LEVEL_LABELS = {
  [SUPPLIER_RISK_CLASSIFICATION.VERY_LOW]: 'Muy Bajo',
  [SUPPLIER_RISK_CLASSIFICATION.LOW]: 'Bajo',
  [SUPPLIER_RISK_CLASSIFICATION.MEDIUM]: 'Medio',
  [SUPPLIER_RISK_CLASSIFICATION.HIGH]: 'Alto',
  [SUPPLIER_RISK_CLASSIFICATION.EXTREME]: 'Extremo',
}
const CATEGORY_LABELS = {
  [SUPPLIER_CATEGORIES.CRITICAL]: 'Crítico',
  [SUPPLIER_CATEGORIES.NON_CRITICAL]: 'No Crítico',
}
const STATUS_REVIEWED = 'Revisado'
const STATUS_PENDING = 'Pendiente'
export const SUPPLIERS_LIST = {
  HIDE_INTERNAL_APPS: 'Ocultar apps internas',
  INTERNAL_APP: 'Interna',
  UPLOAD_SUPPLIERS: 'Cargar Proveedores',
  DOWNLOAD_TEMPLATE: 'Descargar Plantilla para Carga Masiva',
  ADD_SUPPLIER: 'Agregar Proveedor',
  TITLE: 'Proveedores',
  SEARCH_PLACEHOLDER: 'Buscar proveedores...',
  NAME: 'Nombre',
  RESPONSIBLE: 'Responsable',
  PERSONAL_DATA: 'Datos Personales',
  RISK_LEVEL: 'Nivel de Riesgo',
  CATEGORY: 'Categoría',
  DEPARTMENT: 'Departamento',
  SECURITY_STATUS: 'Estado de Seguridad',
  REVIEW_STATUS: 'Estado de Revisión',
  COMPLIANT: 'Compliant',
  NON_COMPLIANT: 'Non-Compliant',
  REVIEWED: STATUS_REVIEWED,
  PENDING: STATUS_PENDING,
  PERSONAL_DATA_LABELS,
  RISK_LEVEL_LABELS,
  CATEGORY_LABELS,
  SUCCESS_UPLOAD_SUPPLIERS: 'Proveedores cargados correctamente',
  ERROR_UPLOAD_SUPPLIERS: 'Error al cargar proveedores',
  UPLOADING_SUPPLIERS: 'Cargando proveedores...',
  BULK_UPLOAD_TITLE: 'Carga Masiva de Proveedores',
  BULK_UPLOAD_DESCRIPTION: 'Sube un archivo CSV o Excel para crear múltiples proveedores a la vez.',
  BULK_UPLOAD: 'Carga Masiva',
  EXPORT: 'Exportar CSV',
  EXPORT_EMPTY: 'Todavía no hay proveedores que exportar.',
}

export const SUPPLIERS_DETAILS = {
  TITLE: 'Detalles del Proveedor',
  GENERAL_INFORMATION: 'Información General',
  NAME: 'Nombre',
  WEBSITE: 'Sitio Web',
  RESPONSIBLE: 'Responsable',
  DEPARTMENT: 'Departamento',
  MANAGE_PERSONAL_DATA: 'Gestionar Datos Personales',
  SECURITY_RELATED_INFORMATION: 'Información de Seguridad',
  RISK_CLASSIFICATION: 'Nivel de Riesgo',
  CATEGORY: 'Categoría',
  SERVICE_TYPE: 'Tipo de Servicio',
  SAAS: 'SaaS',
  ON_PREMISE: 'On-Premise',
  SAAS_TRUE: 'Sí',
  SAAS_FALSE: 'No',
  RESPONSE_EXPECTATIONS: 'Expectativas de Respuesta',
  RESPONSE_EXPECTATIONS_TRUE: 'Sí',
  RESPONSE_EXPECTATIONS_FALSE: 'No',
  SECURITY_CERTIFICATION: 'Certificación de Seguridad',
  SECURITY_CERTIFICATION_TRUE: 'OK',
  SECURITY_CERTIFICATION_FALSE: 'KO',
  SECURITY_COMPLIANCE_STATUS: 'Estado de Cumplimiento de Seguridad',
  SECURITY_COMPLIANCE_STATUS_TRUE: 'Compliant',
  SECURITY_COMPLIANCE_STATUS_FALSE: 'Non-Compliant',
  REVIEW_RELATED_INFORMATION: 'Información de Revisión',
  SUPPLIER_CONTACT_NAME: 'Nombre del Contacto del Proveedor',
  CONTRACT: 'Contrato',
  CONTRACT_LINK: 'Ver Contrato',
  SECURITY_QUESTIONNAIRE: 'Cuestionario de Seguridad',
  SECURITY_QUESTIONNAIRE_LINK: 'Ver Cuestionario de Seguridad',
  REVIEW_STATUS: 'Estado de Revisión',
  DATE_LAST_REVIEW: 'Fecha de Última Revisión',
  DATE_NEXT_REVIEW: 'Fecha de Próxima Revisión',
  FINDINGS_EVALUATION: 'Evaluación de Hallazgos',
  NOTES: 'Notas',
  PERSONAL_DATA_LABELS,
  RISK_LEVEL_LABELS,
  CATEGORY_LABELS,
  STATUS_REVIEWED,
  STATUS_PENDING,
  DELETE_DIALOG: {
    TITLE: 'Eliminar Proveedor',
    QUESTION: '¿Estás seguro de querer eliminar el proveedor ',
    CANCEL: 'Cancelar',
    DELETE: 'Eliminar',
  },
}

export const SUPPLIER_CREATION_DIALOG = {
  CREATE: 'Crear Proveedor',
}

export const SUPPLIER_FORM = {
  BASIC_INFORMATION: 'Información Básica',
  NAME: 'Nombre',
  NAME_PLACEHOLDER: 'Nombre del proveedor',
  RESPONSIBLE: 'Responsable',
  WEBSITE: 'Sitio Web',
  CONTACT_NAME: 'Nombre de Contacto',
  CONTACT_NAME_PLACEHOLDER: 'Nombre de contacto',
  DATA_MANAGEMENT: 'Gestión de Datos',
  MANAGE_PERSONAL_DATA: 'Gestionar Datos Personales',
  SELECT_MANAGE_PERSONAL_DATA: 'Seleccionar...',
  CONTRACT_RISK: 'Contrato y Riesgo',
  CONTRACT_URL: 'URL del Contrato',
  CONTRACT_URL_PLACEHOLDER: 'https://example.com/contract',
  RISK_CLASSIFICATION: 'Clasificación de Riesgo',
  SELECT_RISK_CLASSIFICATION: 'Seleccionar...',
  SERVICE_TYPE: 'Tipo de Servicio',
  IS_SAAS: 'Es SaaS',
  RESPONSE_EXPECTATIONS: 'Expectativas de Respuesta',
  SECURITY_COMPLIANCE: 'Seguridad y Cumplimiento',
  SECURITY_CERTIFICATION_URL: 'URL de Certificación de Seguridad',
  SECURITY_CERTIFICATION_URL_PLACEHOLDER: 'https://example.com/security-certification',
  SECURITY_QUESTIONNAIRE_URL: 'URL del Cuestionario de Seguridad',
  SECURITY_QUESTIONNAIRE_URL_PLACEHOLDER: 'https://example.com/questionnaire',
  REVIEW: 'Revisión',
  REVIEW_DATE: 'Fecha de Revisión',
  FINDINGS_EVALUATION: 'Evaluación de Hallazgos',
  FINDINGS_STATUS: 'Estado OK',
  FINDINGS_NOTES_PLACEHOLDER: 'Notas...',
  SELECT_DATE_PLACEHOLDER: 'Seleccionar fecha',
  NEXT_REVIEW_EMPTY: 'Establecer fecha de última revisión',
  SELECT_RISK_LEVEL: 'Seleccionar nivel de riesgo',
  CATEGORY_EMPTY: 'Establecer categoría',
  CATEGORY_HELP:
    'Se establece de forma independiente al nivel de riesgo. Los proveedores críticos se revisan con mayor frecuencia.',
  SECURITY_STATUS_HELP:
    'Cumple cuando se proporciona una URL de certificación de seguridad o de cuestionario de seguridad.',
  NEXT_REVIEW_HELP:
    'Proveedores Críticos: +1 año desde última revisión. Proveedores No Críticos: +2 años desde última revisión.',
  REVIEW_STATUS_HELP: 'Pendiente si la próxima revisión es en 30 días o está vencida. Revisado en caso contrario.',
}

export const SUPPLIER_MESSAGES = {
  CREATING: 'Creando proveedor...',
  CREATED: (name: string) => `Proveedor ${name} creado correctamente`,
}
